"use client";

import { Link } from "@/components/common/Link";
export default function ArchitecturalWallSolutions() {
  const courses = [{
    index: "01",
    label: "SYSTEM 01",
    name: "Hardie Siding",
    description: "Engineered fiber cement siding that offers unmatched durability and a classic aesthetic for Calgary homes.",
    origin: "Fiber Cement · Premium Grade",
    ghost: "01",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/james_hardie_siding.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/james_hardie_siding.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/james_hardie_siding.webp-wvc-sizes"
  }, {
    index: "02",
    label: "SYSTEM 02",
    name: "Board and Batten",
    description: "A classic vertical siding style reimagined with modern materials for a farmhouse or contemporary look.",
    origin: "Vertical Profile · Timeless Design",
    ghost: "02",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Board-and-batten-siding.png?v=zrfw3oualxl",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Board-and-batten-siding.png?v=3zl1m42d9py-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Board-and-batten-siding.png?v=ed8k7thn8gn-wvc-sizes"
  }, {
    index: "03",
    label: "SYSTEM 03",
    name: "Aluminum Siding",
    description: "Premium aluminum siding with realistic wood finishes, offering fire resistance and low maintenance.",
    origin: "Extruded Aluminum · Wood Series",
    ghost: "03",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Longboard-aluminum-siding.png?v=q10vl0uldtk",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Longboard-aluminum-siding.png?v=a9xvyxdmwiq-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Longboard-aluminum-siding.png?v=dgte3xijg2a-wvc-sizes"
  }, {
    index: "04",
    label: "SYSTEM 04",
    name: "Acrylic Stucco",
    description: "A flexible, multi-layered finish providing excellent weather resistance and a clean, contemporary appearance.",
    origin: "Polymer Finish · Thermal Shield",
    ghost: "04",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Acrylic-Stucco.png?v=c4m0pdfcu0k",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Acrylic-Stucco.png?v=racd72w0c2-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Acrylic-Stucco.png?v=0hiavgt5tato-wvc-sizes"
  }, {
    index: "05",
    label: "SYSTEM 05",
    name: "LP SmartSide",
    description: "Advanced engineered wood technology providing the warmth of cedar with superior impact resistance.",
    origin: "Engineered Wood · High Durability",
    ghost: "05",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/lp_smartside_cladding.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/lp_smartside_cladding.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/lp_smartside_cladding.png-wvc-sizes"
  }, {
    index: "06",
    label: "SYSTEM 06",
    name: "Lux Panels",
    description: "High-performance steel cladding that replicates natural wood grain without the maintenance of real timber.",
    origin: "Architectural Steel · Wood Grain",
    ghost: "06",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Lux-Panels.png?v=7medet0jvb7",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Lux-Panels.png?v=mb904scpmac-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Lux-Panels.png?v=y40rq9845r-wvc-sizes"
  }, {
    index: "07",
    label: "SYSTEM 07",
    name: "Stone Veneer",
    description: "Distinctive stone textures that add natural character, visual depth, and timeless elegance to any exterior.",
    origin: "Natural Texture · Artisan Install",
    ghost: "07",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Stone-Veneer.webp?v=4mhlcrg8bf8",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Stone-Veneer.webp?v=d4jhp8fbbtn-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Stone-Veneer.webp?v=xgrvyt9q4v-wvc-sizes"
  }, {
    index: "08",
    label: "SYSTEM 08",
    name: "Brick and Brick Veneer",
    description: "Classic masonry and veneer combinations offering timeless elegance with superior durability and authentic craftsmanship.",
    origin: "Natural Masonry · Traditional Artistry",
    ghost: "08",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Brick-and-Brick-Veneer.png?v=czl4dif8xlk",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Brick-and-Brick-Veneer.png?v=u4fha5kaxwp-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Brick-and-Brick-Veneer.png?v=4tv8mxrvuhl-wvc-sizes"
  }, {
    index: "09",
    label: "SYSTEM 09",
    name: "Corrugated Metal",
    description: "Durable and cost-effective metal panels that offer a modern industrial vibe for residential accents.",
    origin: "Galvanized Steel · Industrial Chic",
    ghost: "09",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Corrugated-metal.png?v=um748c3v3nt",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Corrugated-metal.png?v=3ukpi1eeemx-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Corrugated-metal.png?v=jt2ewn2zkve-wvc-sizes"
  }, {
    index: "10",
    label: "SYSTEM 10",
    name: "Cedar Shakes",
    description: "Natural cedar shakes offering distinctive texture, timeless character, and lasting exterior appeal.",
    origin: "Natural Wood · Traditional Craft",
    ghost: "10",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Cedar-shakes.png?v=w42owfczv5",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Cedar-shakes.png?v=5qv90gghfip-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Cedar-shakes.png?v=mcqikmzyhw-wvc-sizes"
  }, {
    index: "11",
    label: "SYSTEM 11",
    name: "Standing Seam Walls",
    description: "Vertical metal panels with concealed fasteners, delivering clean architectural lines and dependable weather protection.",
    origin: "Heavy Gauge Steel · Vertical Seam",
    ghost: "11",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Standing-seam-walls.png?v=3o945l959eh",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Standing-seam-walls.png?v=eleds7paau-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Standing-seam-walls.png?v=v7jlgct515n-wvc-sizes"
  }, {
    index: "12",
    label: "SYSTEM 12",
    name: "Insulated Metal Panels",
    description: "An integrated exterior-envelope solution combining continuous insulation, weather protection, and lasting durability.",
    origin: "Thermal Composite · High Efficiency",
    ghost: "12",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Insulated-metal-panels.png?v=r7dgusqh8r9",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Insulated-metal-panels.png?v=9wt67cdk3h9-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Insulated-metal-panels.png?v=h5ybo61rbod-wvc-sizes"
  }, {
    index: "13",
    label: "SYSTEM 13",
    name: "ACM Panels",
    description: "Sleek aluminum composite panels delivering clean architectural lines, versatile design options, and lasting exterior performance.",
    origin: "Aluminum Composite · Modern Edge",
    ghost: "13",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Aluminum-composite-panels-acm.png?v=mivdzie6jen",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Aluminum-composite-panels-acm.png?v=rdbtg1zw5be-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Aluminum-composite-panels-acm.png?v=8orajmvu0p-wvc-sizes"
  }];
  return <section data-section-id="1026" id="architectural-wall-solutions" className="bg-white text-foreground !p-0">
      <div className="mx-auto max-w-[1440px] px-5 md:px-12">
        <div className="relative mt-12 md:mt-16">
          
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full min-w-0">
          {courses.map((course, i) => <article key={i} data-index={i} className="group relative bg-card border border-border transition-all duration-300 flex flex-col h-full w-full min-w-0 ![padding:10px_32px_10px_32px] hover:border-primary hover:shadow-lg hover:-translate-y-1">
              <div className="relative z-10 flex flex-col h-full">
                <span className="pointer-events-none absolute top-2 left-2 w-3 h-3 border-t border-l border-border"></span>
                <span className="pointer-events-none absolute top-2 right-2 w-3 h-3 border-t border-r border-border"></span>
                <span className="pointer-events-none absolute bottom-2 left-2 w-3 h-3 border-b border-l border-border"></span>
                <span className="pointer-events-none absolute bottom-2 right-2 w-3 h-3 border-b border-r border-border"></span>

                <span aria-hidden="true" className="pointer-events-none absolute font-default font-bold text-foreground select-none transition-opacity duration-300" style={{
              opacity: 0.04,
              fontSize: "clamp(7rem, 14vw, 12rem)",
              right: "0.5rem",
              bottom: "-1rem",
              lineHeight: 1
            }}>
                  {course.ghost}
                </span>

                <div className="relative overflow-hidden w-full" style={{
              aspectRatio: "1 / 1"
            }}>
                  <img src={course.image} data-wvc-srcset={course.srcset} data-wvc-sizes={course.sizes} alt={course.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
                </div>

                <div className="flex flex-col flex-grow min-w-0">
                  <h3 className="font-default font-semibold text-foreground mt-6 relative z-10 break-words min-w-0" style={{
                fontSize: "1.75rem",
                letterSpacing: "-0.01em",
                lineHeight: 1.15
              }}>
                    {course.name}
                  </h3>

                  <div className="relative mt-4">
                    <div className="h-px bg-primary" style={{
                  width: "60px"
                }}></div>
                  </div>

                  <p className="font-default text-muted-foreground mt-4 relative z-10" style={{
                fontSize: "clamp(1.125rem, 1.5vw, 1.375rem)",
                lineHeight: 1.6
              }}>
                    {course.description}
                  </p>

                  <div className="mt-4 relative z-10">
                    <span className="font-mono uppercase text-muted-foreground break-words min-w-0 block" style={{
                  fontSize: "0.625rem",
                  letterSpacing: "0.18em",
                  lineHeight: 1.5
                }}>
                      {course.origin}
                    </span>
                  </div>

                  <div className="mt-auto pt-8 relative z-10">
                    <Link to="/ContactPage" className="inline-flex items-center justify-center min-h-[44px] font-mono text-[0.75rem] tracking-[0.2em] uppercase text-primary border border-primary px-6 py-3 transition-colors duration-300 hover:bg-primary hover:text-white rounded-lg">
                      Request Quote
                    </Link>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-20 flex justify-center">
          
        </div>
      </div>
    </section>;
}